export default "__VITE_ASSET__xn0taeEh__"